<template>
  <el-select
    v-model="roleModel"
    @change="roleChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.ROLE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getRoles"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.ALL_ROLES')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="role in roles"
      :key="role.id"
      :value="role.id"
      :label="`${role.system ? '(S) ' : ''} ${role.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "role-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    role: {
      type: String,
      default: null,
      description: "Role id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    ignoreLocationFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      roleModel: this.role,
      roles: {},
    };
  },

  setup() {},

  created() {
    this.getRoles(null, this.role);
  },

  methods: {
    async getRoles(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { name: query } : {}),
            ...(id ? { with_ids: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterReseller) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              reseller: this.filterReseller,
            },
          };
        }

        if (this.ignoreLocationFilter) {
          params = {
            ...params,
            ignore_location_filter: true,
          };
        }

        await this.$store.dispatch("roles/list", params);
        const rolesArr = await this.$store.getters["roles/list"];
        this.roles = {};
        rolesArr.forEach((role) => {
          this.roles[role.id] = role;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    roleChanged(roleId) {
      const role = Object.values(this.roles).find((item) => item.id === roleId);
      this.$emit("roleChanged", roleId, role);
    },
  },

  watch: {
    role(role) {
      if (role) {
        this.roleModel = role;
        if (role !== this.roleModel) {
          this.getRoles(null, role);
        }
      } else {
        this.roleModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getRoles();
    },
    filterReseller(filterReseller) {
      this.getRoles();
    },
  },
};
</script>
